<template>
  <section id="dashboard">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="CopyIcon"
          icon-right
          statistic="Referral Link Left"
          :statisticTitle="
            dashboard.isQualified
              ? `${url}/#/register/?referral_code=${connectedAccount}&side=left`
              : hideReferral
          "
          color="dark"
          copyToClipboard
        />
      </div>

      <div class="vx-col w-full md:w-1/2">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="CopyIcon"
          icon-right
          statistic="Referral Link Right"
          :statisticTitle="
            dashboard.isQualified
              ? `${url}/#/register/?referral_code=${connectedAccount}&side=right`
              : hideReferral
          "
          color="dark"
          copyToClipboard
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 xl:w-1/2">
        <div class="vx-row">
          <div class="vx-col w-full md:w-1/2">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="ChevronsLeftIcon"
              icon-right
              :statistic="dashboard.myLeftBalance"
              :statisticTitle="`Left Balance (${dashboard.myLeftCount})`"
              color="warning"
            />
          </div>

          <div class="vx-col w-full md:w-1/2">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="ChevronsRightIcon"
              icon-right
              :statistic="dashboard.myRightBalance"
              :statisticTitle="`Right Balance (${dashboard.myRightCount})`"
              color="warning"
            />
          </div>

          <div class="vx-col w-full md:w-1/2">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="CreditCardIcon"
              icon-right
              :statistic="dashboard.myUsdtInvestment"
              statisticTitle="USDT Invesment"
            />
          </div>

          <div class="vx-col w-full md:w-1/2">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="CreditCardIcon"
              icon-right
              :statistic="dashboard.myEcsInvestment"
              statisticTitle="ECG Invesment"
            />
          </div>

          <div class="vx-col w-full md:w-1/2">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="ClipboardIcon"
              icon-right
              :statistic="dashboard.myBinaryPoints || 0"
              statisticTitle="Binary Points"
              color="danger"
            />
          </div>
        </div>
      </div>

      <div class="vx-col w-full lg:w-1/2 xl:w-1/2 mb-base">
        <CommissionCard />
      </div>
    </div>
  </section>
</template>

<script>
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import CommissionCard from "@/components/dashboard/CommissionCard.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    StatisticsCardLine,
    CommissionCard,
  },
  data() {
    return {
      hideReferral: `You're not qualified enough to show referral link. Minimum 50$ investment required`,
    };
  },
  computed: {
    ...mapGetters({
      dashboard: "auth/dashboard",
      connectedAccount: "metaMask/connectedAccount",
      user: "auth/user",
      contractInfo: "contract/contractInfo",
    }),

    url() {
      return window.location.origin;
    },
  },

  methods: {
    ...mapActions({
      getDashboardData: "auth/getDashboardData",
      getBaseInfo: "contract/getBaseInfo",
    }),

    // Top Seller Title
    topSellerTitle(index) {
      if (index == 0) return "1st";
      if (index == 1) return "2nd";
      if (index == 2) return "3rd";
      if (index == 3) return "4th";
      if (index == 4) return "5th";
    },
    //

    // Top Seller Color
    topSellerColor(index) {
      if (index == 0) return "warning";
      if (index == 1) return "success";
      return "danger";
    },

    // Get Dashboard Data
    async get_Dashboard_Data() {
      // Start Loading
      this.$vs.loading();
      //
      await this.getBaseInfo();
      await this.getDashboardData();
      // Close Loading
      this.$vs.loading.close();
      //
    },
  },
  async mounted() {
    await this.get_Dashboard_Data();
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
@import "./dashabord.scss";
</style>
